import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { Box } from "@mui/material";

const LogoutIcon = (props: SvgIconProps) => {
  return (
    <Box
      component="img"
      src="/icons/exit.png"
      alt="sair da conta"
      sx={{
        width: '24px !important',
        height: '24px !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'block',
        flexShrink: 0,
        ...props.sx
      }}
    />
  );
};

const HomeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2915 14.1384C10.5492 14.1045 10.7858 14.2841 10.8199 14.5396L11.8516 22.2472C11.8517 22.2477 11.8517 22.2481 11.8518 22.2485C11.8756 22.4125 12.0173 22.5343 12.1845 22.5343H19.8165C19.9837 22.5343 20.1254 22.4125 20.1492 22.2485C20.1493 22.2481 20.1493 22.2476 20.1494 22.2472L21.181 14.5396C21.2152 14.2841 21.4518 14.1045 21.7095 14.1384C21.9671 14.1723 22.1482 14.4069 22.114 14.6624L21.0819 22.3733L21.0815 22.3766C20.9931 23.0022 20.4535 23.4677 19.8165 23.4677H12.1845C11.5475 23.4677 11.0079 23.0022 10.9195 22.3766L10.9191 22.3733L9.88696 14.6624C9.85276 14.4069 10.0339 14.1723 10.2915 14.1384Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2243 10.4777C16.0923 10.3756 15.9077 10.3756 15.7757 10.4777L15.4891 10.1131L15.7757 10.4777L8.75997 15.9025C8.55501 16.0609 8.25931 16.0246 8.0995 15.8214C7.93969 15.6181 7.97629 15.3249 8.18125 15.1664L15.197 9.74162C15.6692 9.37649 16.3308 9.37649 16.803 9.74162L23.8188 15.1664C24.0237 15.3249 24.0603 15.6181 23.9005 15.8214C23.7407 16.0246 23.445 16.0609 23.24 15.9025L16.2243 10.4777Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8238 16.468C18.8238 18.0144 17.5597 19.268 16.0003 19.268C14.4409 19.268 13.1768 18.0144 13.1768 16.468C13.1768 14.9216 14.4409 13.668 16.0003 13.668C17.5597 13.668 18.8238 14.9216 18.8238 16.468ZM16.0003 18.3346C17.0399 18.3346 17.8826 17.4989 17.8826 16.468C17.8826 15.437 17.0399 14.6013 16.0003 14.6013C14.9607 14.6013 14.1179 15.437 14.1179 16.468C14.1179 17.4989 14.9607 18.3346 16.0003 18.3346Z"
        fill="#D6D6D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5878 20.2012C14.3279 20.2012 14.1172 20.4101 14.1172 20.6678C14.1172 20.9256 14.3279 21.1345 14.5878 21.1345H17.4113C17.6712 21.1345 17.8819 20.9256 17.8819 20.6678C17.8819 20.4101 17.6712 20.2012 17.4113 20.2012H14.5878Z"
        fill="#D6D6D6"
      />
    </SvgIcon>
  );
};

const WelcomeBackgroundIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <rect
        x="8.5"
        y="18.3013"
        width="5.6666"
        height="5.6666"
        rx="0.5"
        stroke="#D6D6D6"
      />
      <rect
        x="17.833"
        y="18.3013"
        width="5.6666"
        height="5.6666"
        rx="0.5"
        stroke="#D6D6D6"
      />
      <rect
        x="8.5"
        y="8.96777"
        width="5.6666"
        height="5.6666"
        rx="0.5"
        stroke="#D6D6D6"
      />
      <rect
        x="17.833"
        y="8.96777"
        width="5.6666"
        height="5.6666"
        rx="0.5"
        stroke="#D6D6D6"
      />
    </SvgIcon>
  );
};

const ProductsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        d="M23.2529 18.3713L17.9024 23.7212L10.0208 15.8389L10.0107 10.479H15.3644L23.2529 18.3713Z"
        stroke="#D6D6D6"
        strokeLinejoin="round"
      />
      <path
        d="M14.1098 13.3164C13.4133 13.3164 12.8486 13.881 12.8486 14.5776C12.8486 15.2741 13.4133 15.8387 14.1098 15.8387C14.8063 15.8387 15.371 15.2741 15.371 14.5776C15.371 13.881 14.8063 13.3164 14.1098 13.3164Z"
        stroke="#D6D6D6"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 9.21777L12.8488 13.3165"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const MeasureIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        d="M13.5653 24.4677H8V18.9023"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5653 8.46777H8V14.0331"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4346 24.4677H23.9999V18.9023"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4346 8.46777H23.9999V14.0331"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1309 20.9899C11.1309 18.3227 13.3333 16.8159 16.0005 16.8159C18.6684 16.8159 20.8701 18.3227 20.8701 20.9899M17.9681 12.0655C19.0548 13.1522 19.0548 14.9141 17.9681 16.0008C16.8814 17.0875 15.1195 17.0875 14.0328 16.0008C12.9461 14.9141 12.9461 13.1522 14.0328 12.0655C15.1195 10.9788 16.8814 10.9788 17.9681 12.0655Z"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const StreamIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        d="M16.333 17.8343H14.6663C14.393 17.8343 14.1663 17.6076 14.1663 17.3343C14.1663 17.061 14.393 16.8343 14.6663 16.8343H16.333C18.0797 16.8343 19.4997 15.4143 19.4997 13.6676C19.4997 11.921 18.0797 10.501 16.333 10.501H12.9997C11.253 10.501 9.83301 11.921 9.83301 13.6676C9.83301 14.401 10.093 15.1143 10.5597 15.681C10.733 15.8943 10.7063 16.2076 10.493 16.3876C10.2797 16.561 9.96634 16.5343 9.78634 16.321C9.17301 15.5743 8.83301 14.6343 8.83301 13.6676C8.83301 11.3676 10.6997 9.50098 12.9997 9.50098H16.333C18.633 9.50098 20.4997 11.3676 20.4997 13.6676C20.4997 15.9676 18.633 17.8343 16.333 17.8343Z"
        fill="#D6D6D6"
      />
      <path
        d="M19 22.5008H15.6667C13.3667 22.5008 11.5 20.6341 11.5 18.3341C11.5 16.0341 13.3667 14.1675 15.6667 14.1675H17.3333C17.6067 14.1675 17.8333 14.3941 17.8333 14.6675C17.8333 14.9408 17.6067 15.1675 17.3333 15.1675H15.6667C13.92 15.1675 12.5 16.5875 12.5 18.3341C12.5 20.0808 13.92 21.5008 15.6667 21.5008H19C20.7467 21.5008 22.1667 20.0808 22.1667 18.3341C22.1667 17.6008 21.9067 16.8875 21.44 16.3208C21.2667 16.1075 21.2933 15.7941 21.5067 15.6141C21.72 15.4341 22.0333 15.4675 22.2133 15.6808C22.8333 16.4275 23.1733 17.3675 23.1733 18.3341C23.1667 20.6341 21.3 22.5008 19 22.5008Z"
        fill="#D6D6D6"
      />
    </SvgIcon>
  );
};

const RealtimeProductsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7.96777C16.2191 7.96777 16.4126 8.11036 16.4775 8.31957L18.1389 13.6727C18.2361 13.9862 18.4816 14.2316 18.795 14.3289L24.1482 15.9902C24.3574 16.0552 24.5 16.2487 24.5 16.4678C24.5 16.6868 24.3574 16.8804 24.1482 16.9453L18.795 18.6066C18.4816 18.7039 18.2361 18.9493 18.1389 19.2628L16.4775 24.616C16.4126 24.8252 16.2191 24.9678 16 24.9678C15.7809 24.9678 15.5874 24.8252 15.5225 24.616L13.8611 19.2628C13.7639 18.9493 13.5184 18.7039 13.205 18.6066L7.8518 16.9453C7.64259 16.8804 7.5 16.6868 7.5 16.4678C7.5 16.2487 7.64259 16.0552 7.8518 15.9902L13.205 14.3289C13.5184 14.2316 13.7639 13.9862 13.8611 13.6727L15.5225 8.31957C15.5874 8.11036 15.7809 7.96777 16 7.96777ZM16 10.1547L14.8162 13.9691C14.6213 14.5973 14.1295 15.089 13.5014 15.284L9.68691 16.4678L13.5014 17.6516C14.1295 17.8465 14.6213 18.3383 14.8162 18.9664L16 22.7809L17.1838 18.9664C17.3787 18.3383 17.8705 17.8465 18.4986 17.6516L22.3131 16.4678L18.4986 15.284C17.8705 15.089 17.3787 14.5973 17.1838 13.9691L16 10.1547Z"
        fill="#D6D6D6"
      />
    </SvgIcon>
  );
};

const PollIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        d="M24 12.4678L8 12.4678"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.4678L12 14.4678"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 18.4678L21 22.4678"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 20.4678L8 20.4678"
        stroke="#D6D6D6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const ChatIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 33" fontSize="large">
      <path
        d="M24 14.6852C24 17.5547 21.6522 19.9026 18.7826 19.9026H16.6957L13.913 22.6852V19.9026H13.2174C10.3478 19.9026 8 17.5547 8 14.6852C8 11.8156 10.3478 9.46777 13.2174 9.46777H18.7826C21.6522 9.46777 24 11.8156 24 14.6852Z"
        stroke="#D6D6D6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const UsersIcon = (props: SvgIconProps) => {
  return (
    <Box
      component="img"
      src="/icons/user.png"
      alt="usuários"
      sx={{
        width: '24px !important',
        height: '24px !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'block',
        flexShrink: 0,
        ...props.sx
      }}
    />
  );
};

const TapumesIcon = (props: SvgIconProps) => {
  return (
    <Box
      component="img"
      src="/icons/frontend-default/tapumes.png"
      alt="tapumes"
      sx={{
        width: '32px !important',
        height: '32px !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'block',
        flexShrink: 0,
        ...props.sx
      }}
    />
  );
};

const TextoEIconsIcon = (props: SvgIconProps) => {
  return (
    <Box
      component="img"
      src="/icons/frontend-default/texto-e-icones.png"
      alt="texto e ícones"
      sx={{
        width: '32px !important',
        height: '32px !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'block',
        flexShrink: 0,
        ...props.sx
      }}
    />
  );
};

const ConfigsGeraisIcon = (props: SvgIconProps) => {
  return (
    <Box
      component="img"
      src="/icons/frontend-default/configs-gerais.png"
      alt="configs gerais"
      sx={{
        width: '32px !important',
        height: '32px !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'block',
        flexShrink: 0,
        ...props.sx
      }}
    />
  );
};

export {
  LogoutIcon,
  HomeIcon,
  WelcomeBackgroundIcon,
  ProductsIcon,
  MeasureIcon,
  StreamIcon,
  RealtimeProductsIcon,
  PollIcon,
  ChatIcon,
  UsersIcon,
  TapumesIcon,
  TextoEIconsIcon,
  ConfigsGeraisIcon,
};
